import { NotificationStatus } from "PFCore/types";

import api from "../../api";

export type MarkNotificationAsReadPayload = {
  id: number;
  status?: NotificationStatus;
};

export const markNotificationAsRead = ({
  id,
  status = NotificationStatus.Read
}: MarkNotificationAsReadPayload) =>
  api({
    url: `notifications/${id}`,
    method: "PUT",
    params: {
      status
    }
  });
